import React from "react";

const AddressInfo = ({ addressType = "Address", addressData }) => {
  const { Street1, Street2, City, State, PostalCode, Country } = addressData;

  return (
    <div className="flex-1 min-w-52">
      <h3 className="text-lg font-semibold mb-4">{addressType} Information</h3>
      <div className="text-gray-600 max-w-sm space-y-1 ">
        {Street1 && (
          <p>
            <span className="font-bold">Street:</span> {Street1}
          </p>
        )}
        {Street2 && <p>{Street2}</p>}
        {City && <p>{City}</p>}
        {State && <p>{State}</p>}
        {PostalCode && (
          <p>
            <span className="font-bold">Postal Code:</span> {PostalCode}
          </p>
        )}
        {Country && (
          <p>
            <span className="font-bold">Country:</span> {Country}
          </p>
        )}
      </div>
    </div>
  );
};

export default AddressInfo;
